import { createRouter, createWebHistory } from 'vue-router';
import MainLayout from './layouts/MainLayout.vue';
import Pay from './components/Pay.vue';
import RefundRules from './components/RefundRules.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';
import Offer from './components/Offer.vue';
import TariffRules from './components/TariffRules.vue';

const routes = [
	{
		path: '/',
		name: 'MainLayout',
		component: MainLayout
	},
	{
		path: '/pay',
		name: 'Pay',
		component: Pay
	},
	{
		path: '/refund-rules',
		name: 'RefundRules',
		component: RefundRules
	},
	{
		path: '/privacy-policy',
		name: 'PrivacyPolicy',
		component: PrivacyPolicy
	},
	{
		path: '/offer',
		name: 'Offer',
		component: Offer
	},
	{
		path: '/tariff-rules',
		name: 'TariffRules',
		component: TariffRules
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth'
			};
		} else {
			return { top: 0 };
		}
	}
});

export default router;